// import configfile from '../assets/config/config.json'
// import axios from 'axios';
// import Amplify from "aws-amplify";

import {inject} from "vue";

export default {
  name: 'Config',
  data() {
    return {
      config: {}
    }
  },
  methods: {
    // getConfig: function () {
    //     return new Promise(resolve => {
    //         axios.get('/assets/config/config.json').then(res => {
    //             this.config = res.data;
    //             // console.log(this.config.amplifyConfig)
    //             Amplify.configure(this.config.amplifyConfig);
    //
    //             resolve(this.config);
    //         })
    //     });
    // },
  },
  created: function () {
    this.config = inject('$config');
    // this.getConfig();
  }
}

// export appConfig;
